import { CommonModule, DatePipe } from '@angular/common'
import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core'
import { AppReportingPeriod } from '../../models/interfaces/app-reporting-period.interface'
import { TranslateModule } from '@ngx-translate/core'
import { InlineSVGModule } from 'ng-inline-svg-2'
import { SharedModule } from 'primeng/api'
import { TableModule } from 'primeng/table'

@Component({
   selector: 'app-basic-reporting-period-table',
   templateUrl: './app-reporting-period-table.component.html',
   styleUrls: ['./app-reporting-period-table.component.scss'],
   providers: [DatePipe],
   standalone: true,
   imports: [CommonModule, TableModule, SharedModule, InlineSVGModule, TranslateModule]
})
export class AppReportingPeriodTableComponent {
   @Input() readonly?: boolean
   @Input() height: string = '200px'
   @Input() reportingPeriodsArray?: AppReportingPeriod[]

   @Output() deleteReportClick = new EventEmitter()

   ngOnChanges(changes: SimpleChanges): void {
      if (changes['reportingPeriodsArray'] && this.reportingPeriodsArray?.length) {
         this.reportingPeriodsArray = this.getDataSorted([...this.reportingPeriodsArray])
      }
   }

   protected getDataSorted(reportingArray: AppReportingPeriod[]) {
      return [
         ...reportingArray.sort((a, b) => {
            return a?.periodName && b?.periodName ? a.periodName?.localeCompare(b.periodName) : 0
         })
      ]
   }
}
